import { Component } from '@angular/core';

@Component({
    selector: 'tt-info-screen',
    templateUrl: './info-screen.component.html',
    styleUrls: ['./info-screen.component.css'],
})
export class InfoScreenComponent {
    public reloadingData: boolean = false;
    public editable = true;
    public editing = false;
}
